const StatusBadge = ({status}: {status: string}) => {
  const getStatusData = (status: string): {color: string; text: string} => {
    switch (status) {
      case 'pending':
        return {
          color: 'warn',
          text: 'در انتظار تایید',
        };
      case 'reject':
        return {
          color: 'danger',
          text: 'رد شده',
        };
      default:
        return {
          color: '',
          text: '',
        };
    }
  };

  const {color: statusColor, text: statusText} = getStatusData(status);

  return (
    <div>
      <div
        className={`px-2 py-[2px] rounded-lg font-medium ${
          statusColor === 'warn'
            ? 'bg-warning-50 text-warning-500'
            : 'bg-red-50 text-red-600'
        }`}
      >
        <span className="text-xs">{statusText}</span>
      </div>
    </div>
  );
};

export default StatusBadge;
